import axios from 'axios';

const env = "production";
//const env = "localhost";

let baseURL = 'https://api.wowcontent.lol:8443';
let baseWebSocketURL = 'wss://api.wowcontent.lol:8443';
if (env === "localhost") {
    baseURL = 'http://localhost:8081';
    baseWebSocketURL = 'ws://localhost:8081';
} else if (window.location.hostname.endsWith('wowcontent.ru')) {
    baseURL = 'https://api.wowcontent.ru:8443';
    baseWebSocketURL = 'wss://api.wowcontent.ru:8443';
}
export {baseURL};
export {baseWebSocketURL};

const axiosInstance = axios.create({
    baseURL,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

let backendAvailable = true;
const setBackendAvailability = (available) => {
    if (backendAvailable === available) return;
    backendAvailable = available;
    window.dispatchEvent(new CustomEvent('backend-availability-change', { detail: { available } }));
};

axiosInstance.interceptors.response.use(
    (response) => {
        setBackendAvailability(true);
        return response;
    },
    (error) => {
        const status = error.response?.status;
        // No response = network error (server unreachable). 502/503/504 = backend gateway errors during release.
        if (!error.response || status === 502 || status === 503 || status === 504) {
            setBackendAvailability(false);
        } else {
            setBackendAvailability(true);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;